export const adminAreaRoutes = {
  hub: 'admin-area/hub'
};
